export default __webpack_public_path__ + "static/media/1619533969_Homevbbbbmkl.300ad2de.jpg";